import { useContext } from "react";
import GroupByName from "../GroupByName";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";

export default function ServletForm() {
  const parentScreen = useContext(ParentScreenCtx);
  return (
    <>
      {parentScreen === 'inbound' && <GroupByName /> }
    </>
  )
}